import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./ValidateAccount.scss";

function ValidateAccount(props) {
    const { token } = useParams();
    // status: 'loading' | 'success' | 'error'
    const [status, setStatus] = useState("loading");
    const [message, setMessage] = useState("Validation de votre compte en cours...");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setMessage("Lien invalide : jeton manquant.");
            return;
        }

        axios
            .get(`${process.env.REACT_APP_BASE_URL_API}/validate-account/${token}`, {
                headers: props.auth.token
                    ? { accept: "application/json", Authorization: `Bearer ${props.auth.token}` }
                    : { accept: "application/json" },
            })
            .then(() => {
                setStatus("success");
                setMessage(
                    "Votre compte est validé. Un email vient de vous être envoyé pour définir votre mot de passe."
                );
            })
            .catch((error) => {
                setStatus("error");
                setMessage(
                    error.response?.data?.error ||
                        "Une erreur est survenue lors de la validation de votre compte."
                );
            });
    }, [token, props.auth.token]);

    return (
        <div className={`validate-account${status === "error" ? " validate-account--error" : ""}`}>
            <h1 className="validate-account__title">Validation de votre compte</h1>
            <p className="validate-account__message">{message}</p>
            {status !== "loading" && (
                <Link to="/" className="home-link">
                    Retour à la page d’accueil
                </Link>
            )}
        </div>
    );
}

ValidateAccount.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(ValidateAccount);
